import React from 'react'

type InventoryContextValues = {
  filtersDebouncedCounter: number
}

export const InventoryContext = React.createContext<InventoryContextValues>({
  filtersDebouncedCounter: 0,
})
